import React, { useEffect } from 'react';

const EmailRefusal = () => {
  useEffect(() => {
    // 페이지 로드 시 최상단으로 스크롤
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto px-4 py-24 max-w-[1024px]">
      <h1 className="text-3xl font-bold mb-6">이메일 무단수집 거부</h1>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <p className="text-gray-700 mb-4">본 사이트에서 게시된 이메일 주소가 전자우편 수집 프로그램이나 </p>
        <p className="text-gray-700 mb-4">그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, </p>
        <p className="text-gray-700 mb-4">이를 위반 시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다. </p>
      </div>
    </div>
  );
};

export default EmailRefusal;